import { appConstants } from "../../../action-constants/inapp.constants";

let userLogged = localStorage.getItem("mamiVXAuth") || "{}";

let user = JSON.parse(userLogged);

const initialState =
  Object.keys(user).length >= 1
    ? { loggedIn: true, user }
    : { loggedIn: false };

export const getOrderShipmentLabelReducer = (
  state = initialState,
  action: any
) => {
  switch (action.type) {
    case appConstants.GET_SHIPMENT_LABEL_PENDING:
      return {
        request_status: appConstants.GET_SHIPMENT_LABEL_PENDING,
        is_request_processing: true,
        request_data: action,
      };
    case appConstants.GET_SHIPMENT_LABEL_SUCCESS:
      return {
        request_status: appConstants.GET_SHIPMENT_LABEL_SUCCESS,
        is_request_processing: false,
        request_data: action,
      };
    case appConstants.GET_SHIPMENT_LABEL_FAILURE:
      return {
        request_status: appConstants.GET_SHIPMENT_LABEL_FAILURE,
        is_request_processing: false,
        request_data: action,
      };
    case appConstants.GET_SHIPMENT_LABEL_RESET:
      return {
        request_status: appConstants.GET_SHIPMENT_LABEL_RESET,
        is_request_processing: false,
        request_data: {},
      };

    default:
      return { ...state };
  }
};
